import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse } from "schema"

type Response = DataResponse<string[]>

export const shopifyLineItemPropertyKeysQuery = () =>
  queryOptions({
    queryKey: ["shopifyLineItemPropertyKeys"],
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/shopify/line-item-property-keys`)
      return response.data.data
    },
    staleTime: 5 * 60 * 1000,
  })
